export const DEFAULT_PHASES: string[] = [
  "Aguardando atendimento Corretor",
  "Análise de Crédito Realizada",
  "Análise SAFI",
  "Aprovado SAFI",
  "Contrato com pendência comercial",
  "Contrato comunicado",
  "Contrato gerado",
  "Distratado",
  "Em Análise de Crédito",
  "Em atendimento",
  "Proposta",
  "Proposta Aprovada",
  "Proposta Reprovada",
  "Rejeitado SAFI",
  "Reprovado Comissões",
  "Repassado",
  "Visita Agendada",
  "Visita Realizada",
];

const rankingColors: Record<string, string> = {
  Diamante: "#3DB4AE",
  Ouro: "#E69C08",
  Prata: "#878D97",
  Bronze: "#BD6E3D",
  Aço: "#445571",
  "Não elegível": "#CFCFCF",
  "Ranking não disponível": "#59667A",
  "": "#999999",
};

export const handleDefaultRanking = (ranking: string) => rankingColors[ranking];
